import React from "react";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-heading">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

// Sub-header inside a page tab: description on the left, the tab's actions on the right.
export function SectionHeader({ subtitle, actions, testId }) {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-testid={testId}>
      {subtitle ? <p className="text-sm text-slate-500">{subtitle}</p> : <span />}
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

// Primary page action: right-aligned on desktop, full width on phones.
export function ActionRow({ children, testId }) {
  return <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:justify-end" data-testid={testId}>{children}</div>;
}

export function EmptyState({ title, description, testId }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center">
      <p className="text-base font-semibold text-slate-700">{title}</p>
      {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
    </div>
  );
}

export function fmtDate(v) {
  if (!v) return "—";
  // Date-only strings (YYYY-MM-DD) must be parsed as LOCAL, not UTC, or they can
  // render one day off in timezones behind UTC.
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v));
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(v);
  if (isNaN(d)) return String(v).slice(0, 10);
  return d.toLocaleDateString("en-US", m
    ? { year: "numeric", month: "short", day: "numeric" }
    : { timeZone: "America/Chicago", year: "numeric", month: "short", day: "numeric" });
}

export function schoolYear(y) {
  if (y === null || y === undefined || y === "") return "—";
  const n = Number(y);
  if (Number.isNaN(n)) return String(y);
  return `${n} - ${n + 1}`;
}

export function fmtTime(t) {
  if (!t) return "";
  const [hStr, mStr] = String(t).split(":");
  let h = Number(hStr);
  const m = mStr ?? "00";
  if (Number.isNaN(h)) return String(t);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
}

export default PageHeader;
